import React, { useContext } from 'react'
import { LocaleContext } from '../../routes'
import { LabelExtra } from '../../styles/elements'
import { GiftHint } from '../../styles/gift'
import Image from '../../styles/image'
import BottomSheetHint from '../common/BottomSheetHint'
import tickIcon from '../../assets/icons/tick.svg'
import { useHistory } from 'react-router-dom'

export default ({ id, purchaseDate }) => {
  const locale = useContext(LocaleContext)
  const history = useHistory()

  // const gotoStore = () => history.goBack()
  const gotoStore = () => history.replace({ pathname: '/store' })
  const updateGift = () => history.push({
    pathname: `/gift/paid/${id}+${purchaseDate}`,
    state: {
      from: `/gift/pay/${id}`
    }
  })

  return (
    <BottomSheetHint
      cancel={gotoStore}
      cancelText="back_to_store"
      submit={updateGift}
      submitText="show_product"
    >
      <GiftHint>
        <Image alt="succeed" src={tickIcon} width="32px" filter="none" />
        <LabelExtra padding="10px 0 24px" align="center">{locale.PURCHASE_SUCCEEDED}.<br />
          {locale.GIFT_IS_ADDED}.</LabelExtra>
      </GiftHint>
    </BottomSheetHint>
  )
}